module.exports = __webpack_public_path__ + "static/media/case-norwegian-2.1154aa08.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case-norwegian-2.jpg
// module id = 74
// module chunks = 3